import makeRequest from './client';

const baseURL = `/expert-answers`;

export const getAllExpertAnswers = () => {
  const finalURL = `${baseURL}/`;
  return makeRequest(finalURL, 'GET');
};

export const addNewExpertAnswer = (payload: any) => {
  const finalURL = `${baseURL}/`;
  return makeRequest(finalURL, 'POST', payload);
};

export const updateExpertAnswer = (payload: any) => {
  const finalURL = `${baseURL}/`;
  return makeRequest(finalURL, 'PUT', payload);
};

export const getExpertAnswerById = (id: number | string) => {
  const finalURL = `${baseURL}/${id}`;
  return makeRequest(finalURL, 'GET');
};

export const updateExpertAnswerStatus = (id: number | string, status: string) => {
  const finalURL = `${baseURL}/${id}/status`;
  return makeRequest(finalURL, 'PUT', { status });
};
